import { FragranceProfilerResults } from "@/features/profiler/types/FragranceProfilerResults";
import { Separator } from "../../../../../components/ui/Separator";
import { CreateYourOwnStyle } from "./CreateYourOwnStyle";
import { FragranceDetails } from "./FragranceDetails";
import { RecommendedProducts } from "./RecommendedProducts";

type FragranceProfilerDetailedResultsProps = {
  results: FragranceProfilerResults | null;
};

export const FragranceProfilerDetailedResults = ({
  results,
}: FragranceProfilerDetailedResultsProps) => {
  if (!results) return null;
  return (
    <div className="relative h-full w-full bg-[#FBF9F7] flex flex-col items-center overflow-scroll ">
      <img
        src={`/fragrance-profiler/main-fragrances/1.png`}
        alt="Beauty Profiler Results"
        className="w-screen absolute top-0 z-0 bg-cover bg-center blur-[35px] max-w-[1000px]"
      />
      <div className="flex flex-col h-full w-full p-8 gap-9 relative items-center max-w-[1000px]">
        <FragranceDetails feticheFragrance={results.feticheFragrance} />
        <CreateYourOwnStyle
          feticheFragrance={results.feticheFragrance}
          opulenceFragrance={results.opulenceFragrance}
          sensualityFragrance={results.sensualityFragrance}
          mysteryFragrance={results.mysteryFragrance}
          eleganceFragrance={results.eleganceFragrance}
        />
        <Separator />
        <RecommendedProducts
          alsoLikeFeticheFragrance={results.alsoLikeFeticheFragrance}
          alsoLikeLoubiworldFragrance={results.alsoLikeLoubiworldFragrance}
        />
      </div>
    </div>
  );
};
